import { COLORS_3_STEPS_HEALTH } from "../Consts";

export const getAvailabilityColor = (
  availability: number,
  healthyColor = COLORS_3_STEPS_HEALTH[0],
  atRiskColor = COLORS_3_STEPS_HEALTH[1],
  unHealthyColor = COLORS_3_STEPS_HEALTH[2]
) => {
  if (+availability >= 99) {
    return healthyColor;
  } else if (+availability >= 95) {
    return atRiskColor;
  }
  return unHealthyColor;
};

export const getUsedPercentsSpaceColor = (
  usedSpace: number,
  healthyColor: string,
  atRiskColor?: string | undefined,
  unHealthyColor?: string | undefined
) => {
  const healthy = COLORS_3_STEPS_HEALTH[0];
  const atRisk = COLORS_3_STEPS_HEALTH[1];
  const unHealthy = COLORS_3_STEPS_HEALTH[2];
  if (+usedSpace > 10) {
    return healthyColor || healthy;
  } else if (+usedSpace >= 6) {
    return atRiskColor || atRisk;
  }
  return unHealthyColor || unHealthy;
};

export const getMetricChangeDescription = (actualProp: any, typicalProp: any) => {
  if (actualProp === undefined || typicalProp === undefined) {
    return { /*iconType: "empty",*/ message: "", color: "none" };
  }

  let message;
  let color = "none";

  // For metric functions, actual and typical will be single value arrays.
  let actual = 0;
  let typical = 0;
  if (Array.isArray(actualProp)) {
    if (actualProp.length === 1) {
      actual = actualProp[0];
    } else {
      // lat_long anomalies currently the only multi-value case.
      // TODO - do we want to enhance the description depending on detector?
      // e.g. 'Unusual location' if using a lat_long detector.
      return "Unusual values";
    }
  } else {
    actual = actualProp;
  }

  if (Array.isArray(typicalProp)) {
    if (typicalProp.length === 1) {
      typical = typicalProp[0];
    }
  } else {
    typical = typicalProp;
  }

  let factor: number | null = null;
  if (actual === typical) {
    // Very unlikely, but just in case.
    message = "actual same as typical";
  } else {
    // For actual / typical gives output of the form:
    // 4 / 2        2x higher
    // 2 / 10       5x lower
    // 1000 / 1     More than 100x higher
    // 999 / 1000   Unusually low
    // 100 / -100   Unusually high
    // 0 / 100      Unexpected zero value
    // 1 / 0        Unexpected non-zero value
    const isHigher = actual > typical;
    // iconType = isHigher ? "sortUp" : "sortDown";
    if (typical !== 0 && actual !== 0) {
      factor = isHigher ? actual / typical : typical / actual;
      if (factor > 1.5) {
        if (factor <= 100) {
          message = isHigher ? `${Math.round(factor)}x higher` : `${Math.round(factor)}x lower`;
        } else {
          message = isHigher ? "More than 100x higher" : "More than 100x lower";
          color = isHigher ? "danger" : "none";
        }
      } else if (factor >= 1.05) {
        message = isHigher ? `${factor.toPrecision(2)}x higher` : `${factor.toPrecision(2)}x lower`;
      } else {
        message = isHigher ? "Unusually high" : "Unusually low";
      }
    } else {
      if (actual === 0) {
        message = "Unexpected zero value";
      } else {
        message = "Unexpected non-zero value";
      }
    }
  }

  return { /*iconType,*/ message, factor, color };
};
